export default {
	data: () => ({
		logo: require('../../../assets/logo.svg'),
		logoTitle: 'Ortica Systems',
		
		options: {
			filename: `OrticaSystems.pdf`,
			//margin: [20, 0, 10, 0], //top, left, buttom, right
			//margin: [5, 5, 5, 5], //top, left, buttom, right
			image: { type: 'jpeg', quality: 0.98 },
			enableLinks: false,
			html2canvas: {
				scale: 1,
				useCORS: true,
				//scale: 1,
				//bottom: 20
			},
			jsPDF: {
				unit: 'mm',
				format: 'a4',
				orientation: 'portrait'
			},
			pagebreak: { avoid: ['tr'] },
		}
	}),

	props: {
		item: 			{ type: Object, default: () => {} },
		params: 		{ type: Array, default: () => [] },
		//hideBargain: 	{ type: Boolean, default: false }, // Ознака невідображати Коефіцієнт торгу
	},

	computed: {
		id() {
			return this.item.hasOwnProperty('id') ? this.item.id: null;
		},

		title() {
			//return this.item?.type?.name ? this.item.type.name: '';
			return this.item?.title ? this.item.title : (this.item?.type?.name ? this.item.type.name: '');
		},

		filename() {
			//return this.title + ' ' + this.id
			return this.item?.filename ? this.item.filename : (this.title + ' ' + this.id)
		},

		username() {
			return this.item?.user?.name ? this.item.user.name: '';
		},

		parameters() {
			//console.log('pdf', 'VehicleEstimate.vue', 'parameters','item', this.item)

			let result = []
			//------------------------------------------
			if(this.item?.number) result.push({name: "Реєстраційний номер", value: this.item.number})
			if(this.item?.vin) result.push({name: "VIN-код", value: this.item.vin})
			if(this.item?.category?.name) result.push({name: "Категорія", value: this.item.category.name})
			if(this.item?.brand?.name) result.push({name: "Марка", value: this.item.brand.name})
			if(this.item?.model?.name) result.push({name: "Модель", value: this.item.model.name})
			if(this.item?.yearProd) result.push({name: "Рік випуску авто", value: this.item.yearProd})
			if(this.item?.year) result.push({name: "Рік випуску авто", value: this.item.year})
			if(this.item?.generation?.name) result.push({name: "Покоління", value: this.item.generation.name})
			if(this.item?.modification?.name) result.push({name: "Модифікація", value: this.item.modification.name})
			if(this.item?.bodystyle?.name) result.push({name: "Тип кузова", value: this.item.bodystyle.name})
			if(this.item?.driver?.name) result.push({name: "Тип приводу", value: this.item.driver.name})
			if(this.item?.fuel?.name) result.push({name: "Тип палива", value: this.item.fuel.name})
			if(this.item?.gearbox?.name) result.push({name: "Коробка передач", value: this.item.gearbox.name})
			if(this.item?.options?.length) {
				const arr = this.item.options.map(object => object.name);
				const value = arr.join(', ')
				result.push({name: "Опції", value: value})
			}
			if(this.item?.color?.name) result.push({name: "Колір", value: this.item.color.name})
			if(this.item?.country?.name) result.push({name: "Країна виробник", value: this.item.country.name})
			if(this.item?.state?.name) result.push({name: "Область", value: this.item.state.name})
			if(this.item?.city?.name) result.push({name: "Місто", value: this.item.city.name})
			
			/* if(this.item?.mileage?.length) result.push({name: "Пробіг, тис.км", value: this.item.mileage}) */
			/* if(this.item?.mileage) {
				result.push({name: "Пробіг, км", value: this.item.mileage})
			} else {
				if(this.item?.mileageFrom || this.item?.mileageTo) {
					result.push({name: "Пробіг, тис.км", value: (this.item?.mileageFrom ? this.item?.mileageFrom : '...') + ' - ' + (this.item?.mileageTo ? this.item?.mileageTo : '...')})
				}
			} */

			if(this.item?.mileageFrom || this.item?.mileageTo) {
				result.push({name: "Пробіг, тис.км", value: (this.item?.mileageFrom ? this.item?.mileageFrom : '...') + ' - ' + (this.item?.mileageTo ? this.item?.mileageTo : '...')})
			}

			if(this.item?.mileage) {
				result.push({name: "Показник одометра, км", value: this.item.mileage})
			}

			if(this.item?.engineVolume) {
				result.push({name: "Об'єм двигуна, л", value: this.item.engineVolume})
			} else {
				if(this.item?.engineVolumeFrom || this.item?.engineVolumeTo) {
					result.push({name: "Об'єм двигуна, л", value: (this.item?.engineVolumeFrom ? this.item?.engineVolumeFrom : '...') + ' - ' + (this.item?.engineVolumeTo ? this.item?.engineVolumeTo : '...')})
				}
			}
			
			//Параметри для методики
			if(this.item?.odometer) result.push({name: "Показник одометра, км", value: this.item.odometer})
			if(this.item?.mileageAvgNorm) result.push({name: "Нормативний середньорічний пробіг, км", value: this.item.mileageAvgNorm})
			if(this.item?.avgPriceUAH) result.push({name: "Середня ринкова ціна", value: this.item.avgPriceUAH})
			if(this.item?.marketregion?.name) result.push({name: "Ринок регіону", value: this.item.marketregion?.name})
			if(this.item?.bargain && this.item.bargain != 1) result.push({name: "Коефіцієнт торгу", value: this.item.bargain})
			
			return result
		},

		estimates() {
			//console.log('pdf', 'VehicleEstimate.vue', 'estimates','item', this.item)
			//console.log('pdf', 'VehicleEstimate.vue', 'estimates','estimates', this.item.estimates)

			return this.item.hasOwnProperty('estimates') ? this.item.estimates: [];
		},
	},

	methods: {
		generate () {
			//console.log(this.$options.name, 'generate', 'item', this.item)

			this.$refs.html2Pdf.generatePdf()
		},

		async beforeDownload ({ html2pdf, options, pdfContent }) {
			await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
				const totalPages = pdf.internal.getNumberOfPages()
				for (let i = 1; i <= totalPages; i++) {
					pdf.setPage(i)
					pdf.setFontSize(10)
					pdf.setTextColor(150)
					pdf.text('Сторінка ' + i + ' з ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
				} 
			})//.save()
		}
	},
}